export const strings = {
  english: {
    hello: 'Hello ',
    not: ' (not ',
    logout: ' Log out ',
    info: 'From your account dashboard you can view your recent orders, manage your shipping and billing addresses, and edit your password and account details.',
  },

  japan: {
    hello: ' さん、こんにちは (',
    not: ' さんでない場合は',
    not2: ' してください) ',
    logout: ' ログアウト ',
    info: 'お客様の最近の注文を確認できるアカウントダッシュボードから、商品の送付先と請求書の送付先を管理し、パスワードやアカウントの詳細を編集します。',
  },
};
